import * as React from 'react'
import { Undo } from './Undo'

export const Redo: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <Undo style={{ transform: 'scaleX(-1)' }} {...props} />
)
